import React from 'react';
import { DatePicker, FormTitle, Select } from '@maxtropy/components';
import dayjs, { Dayjs } from 'dayjs';
import { DatePickerProps } from 'antd/es/date-picker';
import styles from './index.module.scss';

interface PageHeaderProps {
  date: Dayjs;
  onDateChange: (date: Dayjs) => void;
  onStationChange: (station: string) => void;
  stationOptions: { label: string; value: string }[];
  stationValue: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  date,
  onDateChange,
  onStationChange,
  stationOptions,
  stationValue,
}) => {
  const onDatePickerChange: DatePickerProps['onChange'] = value => {
    if (value) {
      onDateChange(value);
    }
  };

  const disabledDate: DatePickerProps['disabledDate'] = current => {
    // 禁止选择未来时间
    return current && current.isAfter(dayjs().endOf('day'));
  };

  return (
    <div className={styles.pageHeader}>
      <FormTitle title="光伏监测中心" style={{ marginBottom: 0 }} />
      <div className={styles.dateRange}>
        <span>光伏站:</span>
        <Select
          showSearch
          value={stationValue}
          placeholder="请选择"
          options={stationOptions}
          optionFilterProp="label"
          onChange={onStationChange}
          style={{ width: 260, marginLeft: 8 }}
        />
      </div>
      <div className={styles.dateRange}>
        <span>时间选择:</span>
        <DatePicker
          allowClear={false}
          value={date}
          onChange={onDatePickerChange}
          disabledDate={disabledDate}
          format="YYYY-MM-DD"
          style={{ width: 260, marginLeft: 8 }}
        />
      </div>
    </div>
  );
};

export default PageHeader;
